module.exports = __webpack_public_path__ + "static/media/logo@3x.7517580d.png";